import React, { useState } from 'react';
import { ReactComponent as DeleteContentIcon } from '../../assets/svg/DeleteContentIcon.svg';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';

function PracticeSingleStep({
	provided,
	step,
	index,
	steps,
	setSteps,
	practiceNameError,
	practiceDescriptionError,
}: {
	provided: any;
	step: any;
	index: number;
	steps: any;
	setSteps: any;
	practiceNameError: any;
	practiceDescriptionError: any;
}) {
	const [showQuestion, setShowQuestion] = useState(true);

	const _removeValue = (arr: any[], x: any) => {
		arr.splice(x, 1);
		return arr;
	};

	const handleNameChange = (e: any) => {
		let newList = JSON.parse(JSON.stringify(steps));
		newList[index].name = e.target.value;
		setSteps(newList);
	};
	const handleDescriptionChange = (e: any) => {
		let newList = JSON.parse(JSON.stringify(steps));
		newList[index].description = e.target.value;
		setSteps(newList);
	};
	const removeStep = (index: number) => {
		let newList = [...steps];
		newList = _removeValue(newList, index);
		let newReorderList = newList.map((item, index) => {
			return { ...item, order: index + 1 };
		});
		setSteps(newReorderList);
	};
	return (
		<div className='mb-5' ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
			<div className='bg-lightBG rounded-xl p-4  border border-lightBG hover:border-primaryViolet' key={index} id={`question${index}`}>
				<div className=' '>
					<div
						className=' flex flex-row justify-between items-center '
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<p className='text-primaryViolet font-semibold text-base text-left flex-1'>
							Step {step.order} {!showQuestion ? ': ' + step.name : ''}
						</p>

						<div className='flex flex-row pointer justify-between items-center' onClick={() => removeStep(index)}>
							<p className='text-redError font-semibold text-lg mr-3'>Delete</p>
							<DeleteContentIcon fill='#FF747F' />
						</div>

						<button
							className={`flex items-center justify-center min-w-[55px] h-[55px] rounded-full ${showQuestion ? 'bg-white ' : 'bg-primaryViolet'} ml-[35px] cursor-pointer`}
							onClick={() => setShowQuestion((prev) => !prev)}
							style={{ transform: !showQuestion ? 'rotate(180deg)' : 'none' }}
						>
							<AngleUp color={showQuestion ? '#9392AD' : '#ffffff'} />
						</button>
					</div>
					{showQuestion && (
						<div>
							<div className='my-3'>
								<input
									type='text'
									className={`w-full text-deepPurple  border py-3 border-x-0 border-t-0  ${
										practiceNameError && step.name === '' ? 'border-b-redError placeholder-redError' : 'border-b-deselectPurple '
									}  `}
									style={{ backgroundColor: 'transparent' }}
									placeholder={`${practiceNameError && step.name === '' ? `Enter name here` + '*' : `Enter name here`} `}
									value={step?.name}
									onChange={(e) => handleNameChange(e)}
								/>
							</div>
							<div className='my-3'>
								<input
									type='text'
									className={`w-full text-deepPurple  border py-3 border-x-0 border-t-0 ${
										practiceDescriptionError && step.description === '' ? 'border-b-redError placeholder-redError' : 'border-b-deselectPurple '
									}   `}
									style={{ backgroundColor: 'transparent' }}
									placeholder={`${practiceDescriptionError && step.description === '' ? `Enter description here` + '*' : `Enter description here`} `}
									value={step?.description}
									onChange={(e) => handleDescriptionChange(e)}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default PracticeSingleStep;
